import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Divider,
  Flex,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import React from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useOutletContext } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
const CaseNotesViewPage = () => {
  const { edssData, isLoading } = useOutletContext();
  const navigate = useNavigate();
  const initialNotes = edssData?.CASE_NOTES?.FIELDS?.CASE_NOTES || [];

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={5}>
        <FaArrowLeftLong onClick={() => navigate(-1)} cursor="pointer" />
        <Text fontSize="md">Notes View</Text>
      </Box>
      <Divider h="2px" bg="bgColor" />
      <Box my={5}>
        <Accordion defaultIndex={[0]} allowMultiple>
          {initialNotes?.map((note, index) => (
            <AccordionItem
              key={index}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="md"
              mb={2}
            >
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left" px={5}>
                    <Flex justifyContent="space-between">
                      <Text fontSize="xl" fontWeight={500}>
                        {note?.USER?.VALUE}
                      </Text>
                      <Text fontSize="sm" color="gray.600">
                        {moment(note?.MODIFIED_DATE?.VALUE, "YYYYMMDD").format(
                          "MMMM D, YYYY"
                        )}
                      </Text>
                    </Flex>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box>
                  <Text mt={3}>{note?.NOTE?.VALUE}</Text>
                </Box>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </Box>
  );
};

export default CaseNotesViewPage;
